export default __webpack_public_path__ + "static/media/LAS0990.34I-43103_-25770_0.d30ce125.jpg";